<div class="my-3 my-md-5">
  <div class="container">
      <div class="page-header">
          <h1 class="page-title">
              <span *ngIf="!TpaInsId">Adding Tpa Insurance</span>
              <span *ngIf="TpaInsId">Update Tpa Insurance</span>
          </h1>
      </div>
      <div class="card">
          <form [formGroup]="tpaInsuranceForm" (submit)="createTpaInsurance()">
              <div class="card-body">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 right-border">
                          <div class="form-group">
                            <label class="form-label">Tpa *</label>
                            <mat-select  placeholder="Tpa" formControlName="tpa_id">
                                <mat-option *ngFor="let tpa of tpaList;" [value]="tpa.id">{{tpa.name}}</mat-option>

                            </mat-select>
                            <div *ngIf="submitted && f.tpa_id.errors" class="invalid-feedback">
                                <div *ngIf="f.tpa_id.errors.required">Tpa is required</div>
                            </div>
                          </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                          <div class="form-group">
                            <label class="form-label">Insurnace Company *</label>
                            <mat-select  placeholder="Insurance Company" formControlName="ins_comp_id">
                                <mat-option *ngFor="let insComp of insuranceCompanyList" [value]="insComp.id">{{insComp.name}}</mat-option>

                            </mat-select>
                            <div *ngIf="submitted && f.ins_comp_id.errors" class="invalid-feedback">
                                <div *ngIf="f.ins_comp_id.errors.required">Insurance company is required</div>
                            </div>
                          </div>
                      </div>
                    </div>
                      <div class="row">
                          <div class="col-md-6 col-lg-6 right-border">
                            <div class="form-group">
                              <label class="form-label">Gipsa *</label>
                              <mat-select  placeholder="Gipsa" formControlName="gipsa">
                              <mat-option [value]="1">Yes</mat-option>
                              <mat-option [value]="0">No</mat-option>
                              </mat-select>
                              <div *ngIf="submitted && f.gipsa.errors" class="invalid-feedback">
                                <div *ngIf="f.gipsa.errors.required">Gipsa is required</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-6">
                              <div class="form-group">
                                  <label class="form-label">Status *</label>
                                  <mat-select  placeholder="Status" formControlName="status">
                                      <mat-option [value]="1">Active</mat-option>
                                      <mat-option [value]="0">In-Active</mat-option>

                                  </mat-select>
                                  <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                      <div *ngIf="f.status.errors.required">Status is required</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="card-footer">
                  <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i>
                       <span *ngIf="!TpaInsId">Create Tpa Insurance</span>
                      <span *ngIf="TpaInsId">Update Tpa Insurance</span>
                  </button>
              </div>
          </form>
      </div>
  </div>
</div>
